module.exports = __webpack_public_path__ + "static/media/arrowLeft.7b648ba9.svg";